import { formatConfidence } from '../../lib/format'
import { Pill } from '../ui'

/**
 * The reading's confidence, when the payload holds it low (Sprint 1.9.9).
 *
 * The number is the payload's, through the one confidence formatter every
 * screen uses (UI-QA Q8: at most one decimal place, never a percentage), and a
 * null is said in words rather than drawn as a zero. It appears only when the FLAG says low, never because of the number,
 * and "Held low" is Baseline's phrase, so the same fact reads the same across
 * screens. The words are the 1.9.6 teaser's, which the old API's Home still
 * shows.
 */
export function ConfidencePill({ confidence }: { confidence: number | null }) {
  const shown = formatConfidence(confidence)
  return (
    <Pill tone="amber" dot data-testid="home-confidence">
      {shown === null ? 'Confidence · Not available for this session' : `Confidence ${shown} · Held low`}
    </Pill>
  )
}
